const actions = {
	push(context, data: any) {
		(window as any).dataLayer = (window as any).dataLayer || [];
		(window as any).dataLayer.push(data);
	}
};

export default { namespaced: true, actions };
